<template>
  <v-container>
    <template>
    <v-dialog v-model="openFlag" max-width="450px">
      <c-card class="white font-weight-bold pl-5 pt-3" title="이용 통계 다운로드">
        <v-row class="mt-3 mb-3 ml-0">
          <v-btn-toggle dense v-model="type" color="primary" mandatory>
            <v-btn class="mt-2" default value="D">
              일별
            </v-btn>
            <v-btn class="mt-2" value="M">
              월별
            </v-btn>
          </v-btn-toggle>
        </v-row>
        <v-col cols="12" class="pa-0 mt-7">
            <v-col cols="12" class="ma-0 pa-0">
              <v-checkbox
                  label="회원 유형별 이용 현황"
                  v-model="customerTypeFlag"
                  class="mr-3 mt-0 black--text" dense>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0">
              <v-checkbox
                  label="용도별 이용 현황"
                  v-model="usageTypeFlag"
                  class="mr-3 mt-0 black--text" dense>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0">
              <v-checkbox
                  label="결제수단별 요금 현황"
                  v-model="paymentMethodTypeFlag"
                  class="mr-3 mt-0 black--text" dense>
              </v-checkbox>
            </v-col>
        </v-col>

        <v-col cols="12" class="pl-1 pt-3">
          <span class="ml-0">기간 설정</span>
          <v-row id="dateMenu" @input="monthMenu = false" v-bind:class="[type == 'D' ? 'row' : 'd-none']">
          <v-col cols="6" class="pt-0 pl-3">
            <v-menu
                v-model="startPickedDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <div>
                  <v-text-field
                      v-model="startPickedDate"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      class="pt-2"
                  ></v-text-field>
                </div>
              </template>
              <c-date-picker
                  v-model="startPickedDate"
                  @input="selectedDateMenu"
                  firstDayOfWeek="1"
                  :selectedDate="startPickedDate"
                  :min="nowFromThreeMonth"
                  :max="endPickedDate"
                  locale="ko-kr"
              ></c-date-picker>
            </v-menu>
          </v-col>
        <v-col cols="6" class="pt-0 pl-3">
          <v-menu
              v-model="endPickedDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div>
                <v-text-field
                    v-model="endPickedDate"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    class="pt-2"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker
                v-model="endPickedDate"
                @input="selectedDateMenu"
                firstDayOfWeek="1"
                :selectedDate="endPickedDate"
                :min="startPickedDate"
                :max="nowDate"
                locale="ko-kr"
            ></c-date-picker>
          </v-menu>
        </v-col>
        </v-row>

          <v-row id="monthMenu" v-bind:class="[type=='M' ? 'row' : 'd-none']">
            <v-col cols="6" class="pt-0 pl-3">
              <v-menu
                  v-model="startPickedMonthMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div>
                    <v-text-field
                        v-model="startPickedMonth"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        class="pt-2"
                    ></v-text-field>
                  </div>
                </template>
                <c-date-picker type="month" v-model="startPickedMonth" @input="selectedMonthMenu" firstDayOfWeek="1" :selectedDate="startPickedMonth" :min="nowFromThreeMonth" :max="endPickedMonth"></c-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="pt-0 pl-3">
              <v-menu
                  v-model="endPickedMonthMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div>
                    <v-text-field
                        v-model="endPickedMonth"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        class="pt-2"
                    ></v-text-field>
                  </div>
                </template>
                <c-date-picker type="month" v-model="endPickedMonth" @input="selectedMonthMenu" firstDayOfWeek="1" :selectedDate="endPickedMonth" :min="startPickedMonth" :max="nowDate"></c-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <v-row justify="center">
          <c-btn class="mr-1 mt-2" color="blue" outlined @click="forDownload">확인</c-btn>
          <c-btn class="mt-2" color="gray" outlined @click="forCancel">취소</c-btn>
        </v-row>
        <download-excel-dialog
            :open.sync="downloadExcelDialog"
            @reqDownloadExcel="reqDownloadExcel"
        />
      </c-card>
    </v-dialog>
    </template>
  </v-container>
</template>

<script>
import DownloadExcelDialog from "../../Default/Common/DownloadExcelDialog";
import CDatePicker from "@/components/CDatePicker";
import XLSX from "xlsx";

export default {
  name: "DownloadDataDialog",
  components: {
    DownloadExcelDialog
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    downloadExcelDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      openFlag: false,
      pwdShow: false,
      password: "",
      nowFromThreeMonth : this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
      nowDate: this.$func.curDateString(),

      type : 'D',
      customerTypeFlag : false,
      usageTypeFlag : false,
      paymentMethodTypeFlag : false,
      startPickedDate: this.$moment().subtract(1, 'months').startOf('months').format('YYYY-MM-DD'),
      endPickedDate: this.$moment().startOf('months').subtract(1,'days').format('YYYY-MM-DD'),
      startPickedMonth: this.$moment().subtract(6, 'months').format('YYYY-MM'),
      endPickedMonth: this.$moment().subtract(1,'months').format('YYYY-MM'),
      startPickedMonthEdited : 'YYYY-MM-DD',
      endPickedMonthEdited : 'YYYY-MM-DD',

      startPickedDateMenu: false,
      endPickedDateMenu: false,
      startPickedMonthMenu: false,
      endPickedMonthMenu: false,
    }
  },
  methods: {
    async reqDownloadExcel() {
      this.downloadExcelDialog = false;

      let dateType = this.type === 'D' ? "일별" : "월별";
      let startDate = this.type === 'D' ? this.startPickedDate : this.startPickedMonth;
      let endDate = this.type === 'D' ? this.endPickedDate : this.endPickedMonth;

      const setExcel = {
        customerTypeFlag: [
          {
            sheetName: "회원 유형별 탑승 인원 (" + dateType + ")",
            title : "회원 유형별 탑승 인원 (" + dateType + ")_" + startDate + "_" + endDate,
            tableHeaders: [
              ['구분', '일반', '', '교통약자', '', '', '', '', '', '', '', '', '', '보호자', '', '합계(명)', ''],
              ['', '' , '', '장애인', '', '임산부', '', '영유아 가정', '', '영유아', '', '고령자', '', '', '', '', ''],
              ['', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수']

            ],
            merge : [
              { s: { r: 2, c: 0 }, e: { r: 3, c: 0 } }, // 구분
              { s: { r: 2, c: 1 }, e: { r: 3, c: 2 } }, // 일반
              { s: { r: 2, c: 3 }, e: { r: 2, c: 12 } }, // 교통약자
              { s: { r: 3, c: 3 }, e: { r: 3, c: 4 } }, // 장애인
              { s: { r: 3, c: 5 }, e: { r: 3, c: 6 } }, // 임산부
              { s: { r: 3, c: 7 }, e: { r: 3, c: 8 } }, // 영유아 가정
              { s: { r: 3, c: 9 }, e: { r: 3, c: 10 } }, // 영유아
              { s: { r: 3, c: 11 }, e: { r: 3, c: 12 } }, // 고령자
              { s: { r: 2, c: 13 }, e: { r: 3, c: 14 } }, // 보호자
              { s: { r: 2, c: 15 }, e: { r: 3, c: 16 } } // 합계
            ]
          },
          {
            sheetName: "장애 유형별 이용 인원 (" + dateType + ")",
            title : "장애 유형별 이용 인원 (" + dateType + ")_" + startDate + "_" + endDate,
            tableHeaders: [
              ['구분',
                '교통약자(장애인)', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
                '합계(명)', ''],
              ['',
                '간', '', '뇌전증', '', '뇌병변', '', '시각', '', '신장', '', '심장', '', '안면', '', '언어', '', '자폐성', '', '장루, 요루', '', '정신', '', '지적', '', '지체', '', '청각', '', '호흡기', '', '일시적 장애', '', '기타', '',
                '', ''],
              ['', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수',
                '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수',
                '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수', '탑승 인원', '이용자 수']
            ],
            merge : [
              { s: { r: 2, c: 0 }, e: { r: 3, c: 0 } }, // 구분
              { s: { r: 2, c: 1 }, e: { r: 2, c: 34 } }, // 교통약자
              { s: { r: 3, c: 1 }, e: { r: 3, c: 2 } }, // 간
              { s: { r: 3, c: 3 }, e: { r: 3, c: 4 } }, // 뇌전증
              { s: { r: 3, c: 5 }, e: { r: 3, c: 6 } }, // 뇌병변
              { s: { r: 3, c: 7 }, e: { r: 3, c: 8 } }, // 시각
              { s: { r: 3, c: 9 }, e: { r: 3, c: 10 } }, // 신장
              { s: { r: 3, c: 11 }, e: { r: 3, c: 12 } }, // 심장
              { s: { r: 3, c: 13 }, e: { r: 3, c: 14 } }, // 안면
              { s: { r: 3, c: 15 }, e: { r: 3, c: 16 } }, // 언어
              { s: { r: 3, c: 17 }, e: { r: 3, c: 18 } }, // 자폐성
              { s: { r: 3, c: 19 }, e: { r: 3, c: 20 } }, // 장루, 요루
              { s: { r: 3, c: 21 }, e: { r: 3, c: 22 } }, // 정신
              { s: { r: 3, c: 23 }, e: { r: 3, c: 24 } }, // 지적
              { s: { r: 3, c: 25 }, e: { r: 3, c: 26 } }, // 지체
              { s: { r: 3, c: 27 }, e: { r: 3, c: 28 } }, // 청각
              { s: { r: 3, c: 29 }, e: { r: 3, c: 30 } }, // 호흡기
              { s: { r: 3, c: 31 }, e: { r: 3, c: 32 } }, // 일시적 장애
              { s: { r: 3, c: 33 }, e: { r: 3, c: 34 } }, // 기타
              { s: { r: 2, c: 35 }, e: { r: 3, c: 36 } } // 합계
            ]
          }
        ],
        usageTypeFlag: [
          {
            sheetName: "용도별 이용 건수 및 인원 (" + dateType + ")",
            title : "용도별 이용 건수 및 인원 (" + dateType + ")_" + startDate + "_" + endDate,
            tableHeaders: [
              ['구분'],
              [''],
            ],
            merge : [
              { s: { r: 2, c: 0 }, e: { r: 3, c: 0 } }
            ]
          }
        ],
        paymentMethodTypeFlag: [
          {
            sheetName: "결제수단별 요금 현황 (" + dateType + ")",
            title: "결제수단별 요금 현황 (" + dateType + ")",
            tableHeaders: [
              ['구분', '현금', '', '카드', '', '합계', ''],
              ['', '원', '건', '원', '건', '원', '건'],
            ],
            merge : [
              { s: { r: 2, c: 0}, e: { r: 3, c: 0}},
              { s: { r: 2, c: 1}, e: { r: 2, c: 2}},
              { s: { r: 2, c: 3}, e: { r: 2, c: 4}},
              { s: { r: 2, c: 5}, e: { r: 2, c: 6}},
            ]
          }
        ]
      }

      let header_index = 1;
      this.$store.state.centerInfo.useList.split(',').map( header => {
        setExcel.usageTypeFlag[0].tableHeaders[0].push(header,'', '', '')
        setExcel.usageTypeFlag[0].tableHeaders[1].push('주행 건수','탑승 인원','이용 건수','이용자 수')
        setExcel.usageTypeFlag[0].merge.push({ s: { r: 2, c: header_index }, e: { r: 2, c: header_index + 3 } })
        header_index += 4;
      });
      setExcel.usageTypeFlag[0].tableHeaders[0].push('합계','', '', '')
      setExcel.usageTypeFlag[0].tableHeaders[1].push('주행 건수(건)','탑승 인원(명)', '이용 건수(건)', '이용자 수(명)')
      setExcel.usageTypeFlag[0].merge.push({ s: { r: 2, c: header_index }, e: { r: 2, c: header_index + 3 } })

      let queryStartDate = this.type === 'D' ? this.startPickedDate : this.startPickedMonthEdited;
      let queryEndDate = this.type === 'D' ? this.endPickedDate : this.endPickedMonthEdited;

      if(this.customerTypeFlag) {
        let res = await this.$api.getCustomerReportsData(queryStartDate, queryEndDate, this.type);
        setExcel.customerTypeFlag[0].tableRows = res.data.customerTypeSheet;
        setExcel.customerTypeFlag[1].tableRows = res.data.disabilityTypeSheet;
        this.makeExcel("회원 유형별 이용 인원 (" + dateType + ")_" + startDate + "_" + endDate, setExcel.customerTypeFlag, "customerTypeFlag");
      }

      if(this.usageTypeFlag) {
        let res = await this.$api.getPurposeReportsData(queryStartDate, queryEndDate, this.type);
        setExcel.usageTypeFlag[0].tableRows = res.data;
        await this.makeExcel("용도별 이용 건수 및 인원 (" + dateType + ")_" + startDate + "_" + endDate, setExcel.usageTypeFlag, "usageTypeFlag");
      }

      if (this.paymentMethodTypeFlag) {
        const res = await this.$api.getFeeReportsData(queryStartDate, queryEndDate, this.type);
        setExcel.paymentMethodTypeFlag[0].tableRows = res.data;
        this.makeExcel("결제수단별 요금 현황 (" + dateType + ")_" + startDate + "_" + endDate, setExcel.paymentMethodTypeFlag, "paymentMethodTypeFlag");
      }
    },
    async selectedDateMenu() {
      this.nowFromThreeMonth = this.$moment(this.endPickedDate).subtract("6","M").format("YYYY-MM-DD")
      this.startPickedDateMenu = false
      this.endPickedDateMenu = false
    },
    async selectedMonthMenu() {
      this.nowFromThreeMonth = this.$moment(this.endPickedMonth).subtract("6","M").format("YYYY-MM-DD")
      this.startPickedMonthMenu = false
      this.endPickedMonthMenu = false
    },
    forDownload() {
      if (!this.usageTypeFlag && !this.customerTypeFlag && !this.paymentMethodTypeFlag) {
        this.$store.commit('snackbar', {msg : '이용 현황을 선택해주세요.'});
      } else {
        if(this.type == 'M') {
          this.startPickedMonthEdited = this.startPickedMonth + '-01'
          if(this.endPickedMonth < this.$func.curDateString()) {
            //0을 넣으면 그 달의 마지막 날짜가 들어감
            let editedMonth = new Date(this.endPickedMonth.substring(0,4), this.endPickedMonth.substring(5,7), 0)
            this.endPickedMonthEdited = editedMonth.getFullYear() + '-' + ((editedMonth.getMonth() > 8) ? (editedMonth.getMonth() + 1) : ('0' + (editedMonth.getMonth() + 1))) + '-' + ((editedMonth.getDate() > 9) ? editedMonth.getDate() : ('0' + editedMonth.getDate()))
          } else {
            this.endPickedMonthEdited =  this.$func.curDateString()
          }
        }
        this.downloadExcelDialog = true
      }
    },
    async forCancel() {
      this.openFlag = false
      document.getElementById('dateMenu').setAttribute('class', 'row')
      document.getElementById('monthMenu').setAttribute('class', 'd-none')
      Object.assign(this.$data, this.$options.data.call(this));
    },

    makeExcel(fileName, excelData, type) {
      const wb = XLSX.utils.book_new()

      excelData.map( set => {
        let makeExcelData = [];

        makeExcelData.push([set.title]);
        makeExcelData.push([this.$store.state.centerInfo.centerName]);
        set.tableHeaders.map( header => {
          makeExcelData.push(header);
        })
        let colTotals = [];
        let totalSum = [];
        for ( const [index, row] of Object.entries(set.tableRows)) {
          let rowSum = [0];
          let cell = 0;

          row.map( count => {
            count = isNaN(count) ? 0 : parseInt(count);
            colTotals[cell] = (colTotals[cell] ? colTotals[cell] : 0) + count;
            if(type === "usageTypeFlag") {
              rowSum[cell % 4] = isNaN(rowSum[cell % 4]) ? 0 : parseInt(rowSum[cell % 4]);
              rowSum[cell % 4] += count;
              totalSum[cell % 4] = isNaN(totalSum[cell % 4]) ? 0 : parseInt(totalSum[cell % 4]);
              totalSum[cell % 4] += count;
            } else {
              rowSum[cell % 2] = isNaN(rowSum[cell % 2]) ? 0 : parseInt(rowSum[cell % 2]);
              rowSum[cell % 2] += count;
              totalSum[cell % 2] = isNaN(totalSum[cell % 2]) ? 0 : parseInt(totalSum[cell % 2]);
              totalSum[cell % 2] += count;
            }
            cell++;
          })
          row.unshift(index);
          rowSum.map( sum => {
            row.push(sum);  
          })
          makeExcelData.push(row);
        }

        let ratioRow = ["비율"];
        colTotals.map( (colTotal, index) => {
          let sum = type === "usageTypeFlag" ? totalSum[index % 4] : totalSum[index % 2];
          if(sum === 0) {
            ratioRow.push( "-" )
          }else {
            ratioRow.push( Math.round(colTotal / sum * 100) + "%" )
          }
          
        })

        totalSum.map( val => {
          if(val === 0) {
            ratioRow.push( "-" );
          }else {
            ratioRow.push("100%");
          }
          
        })

        colTotals.unshift("합계");
        totalSum.map( val => {
          colTotals.push(val);
        })
        
        makeExcelData.push(colTotals);
        makeExcelData.push(ratioRow);

        let ws = XLSX.utils.aoa_to_sheet(makeExcelData);
        
        ws["!merges"] = set.merge;
        XLSX.utils.book_append_sheet(wb, ws, set.sheetName)
      });

      XLSX.writeFile(wb, fileName + '.xlsx')
    },

  },
  watch: {
    open(newVal) {
      this.openFlag = newVal;
    },
    openFlag(newVal) {
      this.password = "";
      if(newVal === false) {
        this.$emit('update:open', false);
      }
    },
    downloadExcelDialog(newVal) {
      this.$emit('update:downloadExcelDialog', newVal)
    },
  },
}
</script>

<style scoped>
  .black--text /deep/ label {
      color: black;
  }
</style>
